import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/testimonials`)
      .then(res => setTestimonials(res.data))
      .catch(err => console.error("Error fetching testimonials:", err));
  }, []);

  if (testimonials.length === 0) {
    return null; // Viser ingenting hvis det ikke er noen testimonials
  }

  return (
    <section className="page-section testimonials-section">
      <div className="container">
        <h2>Hva sier pasientene våre?</h2>
        <Carousel
          showThumbs={false}
          showStatus={false}
          showArrows={true}
          infiniteLoop
          emulateTouch
          autoPlay
          interval={7000}
        >
          {testimonials.map(testimonial => (
            <div key={testimonial.id} className="testimonial-slide">
              <FontAwesomeIcon icon={faQuoteLeft} className="quote-icon" />
              <p className="quote-text">"{testimonial.quote}"</p>
              <p className="quote-author">- {testimonial.author}</p>
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
}

export default Testimonials;